export default __webpack_public_path__ + "static/best-layover-plan-while-in-the-uk-8a6d81ac7e73715e281882408dc7532c.jpg";